module.exports = __webpack_public_path__ + "media/images/home/book@2x-4b0506081907d0116364a56fdc6778b6.png";